import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private _router: Router) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    let jsontoken = JSON.parse(window.localStorage.getItem('user'));
    let now = new Date();  
    if(jsontoken != null){
        let expired = new Date(jsontoken.Token.expiredAt);
        if(now < expired){
            request = request.clone({
                setHeaders: {  
                  'Content-Type':  'application/json',    
                  Authorization: `Bearer ${jsontoken.Token.access_token}`
                }
              });
        }else{
          request = request.clone({
            setHeaders: {  
              'Content-Type':  'application/json'
            }
          });
        }
    }else{
      request = request.clone({
        setHeaders: {  
          'Content-Type':  'application/json'
        }
      });
    }

    return next.handle(request);
  }
}